var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnchorRotated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 207,
    viewBox: "0 0 184 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M153.781 37.6312C153.781 37.6312 179.315 71.9998 162.521 89.2813C138.5 114 4.49981 28.999 40.2014 131.561",
    stroke: "#54B0C9",
    strokeWidth: 2,
    strokeDasharray: "10 4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8665 156.209C49.6673 156.953 48.7378 157.202 48.1935 156.658L27.9527 136.417C27.2896 135.754 27.8218 134.625 28.7552 134.714L41.3908 135.925C42.0737 135.991 42.7583 135.82 43.3306 135.442L55.8343 127.182C56.6022 126.675 57.5896 127.387 57.3515 128.275L49.8665 156.209Z",
    fill: "#FAFAFA",
    stroke: "#54B0C9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.4251,
    y1: 136.074,
    x2: 49.4962,
    y2: 155.873,
    stroke: "#54B0C9",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchorRotated);
export default __webpack_public_path__ + "static/media/anchor-rotated.8eaebd64b4624b67d2bee70c5a4bbaba.svg";
export { ForwardRef as ReactComponent };